import { createIcon } from "@chakra-ui/react";

const LinkIcon = createIcon({
  displayName: "LinkIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.5303 9.53033L9.53033 15.5303L8.46967 14.4697L14.4697 8.46967L15.5303 9.53033Z"
        fill="currentColor"
      />
      <path
        d="M5.10954 11.7741C3.06765 13.816 3.06765 17.1266 5.10954 19.1685C7.15144 21.2104 10.462 21.2104 12.5039 19.1685L14.422 17.2504L13.3613 16.1897L11.4432 18.1078C9.98712 19.5639 7.62631 19.5639 6.1702 18.1078C4.7141 16.6517 4.7141 14.2909 6.1702 12.8348L8.08832 10.9167L7.02766 9.85603L5.10954 11.7741Z"
        fill="currentColor"
      />
      <path
        d="M9.85609 7.0276L10.9168 8.08826L12.9334 6.07157C14.3895 4.61547 16.7504 4.61547 18.2065 6.07157C19.6626 7.52768 19.6626 9.88849 18.2065 11.3446L16.1898 13.3613L17.2504 14.4219L19.2671 12.4053C21.309 10.3634 21.309 7.0528 19.2671 5.01091C17.2252 2.96902 13.9147 2.96902 11.8728 5.01091L9.85609 7.0276Z"
        fill="currentColor"
      />
    </>
  ),
});

export default LinkIcon;
